export default { sha: 'fda67e5aa6932b350b72539c83f6d778350c984b', buildNumber: 'undefined' }
